module.exports = __webpack_public_path__ + "static/media/large-van.00f7f611.svg";